import React from 'react'
import styled from 'styled-components'
import { FormItem as SutraFormItem } from 'sutra/components/Form'

type FormItemProps = React.ComponentProps<typeof SutraFormItem>

const FormItem: React.FC<FormItemProps> = (props) => (
  <StyledFormItem {...props} />
)

const StyledFormItem = styled(SutraFormItem)`
  margin-bottom: 15px;

  label {
    font-weight: 300;
    color: ${(props) =>
      props.validateStatus === 'error' ? '#FF0033' : '#495057'};
  }
`

export { FormItem }
